
import Table from '@/components/Table.vue';
import TableHeaderButtons from '@/components/TableHeaderButtons.vue'
import SearchPanel from '@/components/SearchPanel.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import { debounce } from 'lodash';
import { buildSearchFilters, buildJsonServerQuery, clearSearchFilters } from '@/utils/app-util';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { vehiculoModule } from '@/store/modules/vehiculos';
import { appModule } from '@/store/modules/app';
import { userModule } from '@/store/modules/user';

@Component({
  components: {
    Table,
    TableHeaderButtons,
    SearchPanel,
    ConfirmDialog
  }
})
export default class BaseList extends Vue {
  public dialog = false;
  private dialogTitle = 'Borrar usuario';
  private dialogText = '¿Quiéres borrar el usuario?';
  public showSearchPanel = false;
  public right = true;
  public search = '';
  public headers = [
    /*{
      text: 'Reference',
      left: true,
      value: 'reference'
    },*/
    { text: 'Nombre', value: 'nombre' },
    { text: '', value: 'actions', sortable: false }
  ];
  private searchFilter = {
    contain: {
      reference: '',
      customer: ''
    },
    greaterThanOrEqual:{
      amount: 0
    },
    lessThanOrEqual:{
      amount: 0
    },
  };
  // private orderId = '';
  private query = '';
  private color = '';
  private itemId = -1;

  edit(item) {
    this.$router.push(`/usuario/${item.id}/permisos`);
  }
  add() {
    this.$router.push(`/usuario/NewUsuario`);
  }
  remove(item) {
    this.itemId = item.id;
    this.dialog = true;
  }

  onConfirm() {
    userModule.deleteUsuario(this.itemId).then(data=>{
      userModule.getUsers();
      appModule.sendSuccessNotice("Usuario borrado correctamente.");
    });
    this.dialog = false;
  }

  onCancel() {
    this.itemId = -1;
    this.dialog = false;
  }

  getVehiculoByIdBase() {
    console.log(this.$route.params.id);
    vehiculoModule.getVehiculoByIdBase(this.$route.params.id);
  }


  clearSearchFilters() {
    this.showSearchPanel = !this.showSearchPanel;
    clearSearchFilters(this.searchFilter);
    this.getVehiculoByIdBase();
  }

  reloadData() {
    this.query = '';
    this.getVehiculoByIdBase();
  }

   updateSearchPanel(){
    this.rightDrawer=!this.rightDrawer;
  }

  cancelSearch() {
    this.showSearchPanel = false;
  }

  closeSnackbar() {
    appModule.closeNotice();
  }

  get items() {
    return userModule.items;
  }
  get pagination() {
    return vehiculoModule.pagination;
  }
  get loading() {
    return appModule.loading;
  }
  get mode() {
    return appModule.mode;
  }
  get snackbar() {
    return appModule.snackbar;
  }
  get notice() {
    return appModule.notice;
  }

  get rightDrawer() {
    return this.showSearchPanel;
  }

  set rightDrawer(_showSearchPanel: boolean) {
    this.showSearchPanel = _showSearchPanel;
  }

  created() {
    if (this.$route.params.id) {
      this.getVehiculoByIdBase();
    } else{
      userModule.getUsers();
    }
  }
  mounted() {
    // this.$nextTick(() => {
    //   console.log(this.headers);
    // });
  }
}
